import { IInsight } from '@jumpstart/core';
import { GraphImage } from '@jumpstart/core/dist/schemas/common';
import Link from '@mui/material/Link';
import request, { gql } from 'graphql-request';
import React, { useEffect, useState } from 'react';
import { GRAPH_CMS_API } from '../../../services/graph-cms/utils';
import ScoutTooltip from '../../../widgets/ScoutTooltip';


export interface IEventFormImageField {
  eventId: string;
}

const placeholder: GraphImage = {
  url: 'https://media.graphcms.com/5nQ0h0D3S9GPSjeZZhtg',
  id: 'placeholder',
  size: 156,
  width: 156,
  height: 156
};

export default function EventFormImageField(props: IEventFormImageField) {
  const { eventId } = props;
  const [image, setImage] = useState<GraphImage | null>(null);
  const [loading, setLoading] = useState(false);

  const getImage = async (id: string): Promise<GraphImage | null> => {
    console.log('Insight', id);
    const query = gql`
  {
    insight(where: {id: "${id}"}) {
      image {
        url
        id
        size
        width
        height
      }
    }
  }
  `;
    const { insight } = await request<{ insight: IInsight | null }>(GRAPH_CMS_API, query);
    return insight && insight.image ? insight.image : null;
  };

  useEffect(() => {
    if (!loading) {
      setLoading(true);
      getImage(eventId)
        .then((img: GraphImage | null) => {
          setImage(img);
          setLoading(false);
        })
        .catch((err: Error) => {
          console.error('Failed to get image', err);
          setLoading(false);
        });
    }
  }, [eventId]);

  // const uploadToGraphCMS = (name: string, value: string | Blob) => {
  //   // graphQLClient.request()
  //   const form = new FormData();
  //
  //   form.append('fileUpload', value, name);
  //   fetch(`${GRAPH_CMS_API}/upload`, {
  //     method: 'POST',
  //     headers: {
  //       Authorization: `Bearer ${GRAPH_CMS_TOKEN}`
  //     },
  //     body: form
  //   });
  // };

  return (
    <ScoutTooltip
      title="Add image in Graph CMS dashboard"
    >
      <Link
        href={`https://app.graphcms.com/d8a43d9d6e4547da83051c63f594b7f0/master/content/648979d9c06d4e2389aa9944ab4d9efe/view/53c18833e12b49a2980754996c104ad5/${eventId}`}
        target={`graphcms_${eventId}`}
        style={{width: '100%'}}
      >
        <img
          style={{
            width: '100%',
            maxHeight: 350,
            objectFit: 'cover',
            transition: '0.3s cubic-bezier(.47,1.64,.41,.8)',
            transform: 'scale(1)',
            '&:hover': {
              transform: 'scale(0.95)',
            },
            '&:active': {
              transform: 'scale(0.98)',
            }
          } as any}
          src={(image ? image : placeholder).url}
          alt="Img"
        />
      </Link>
    </ScoutTooltip>
  );
}
